import NavigationItemController from './navigation_item_controller'

export default class ScrollToItemItemController extends NavigationItemController {
  connect () {
    super.connect()
    this.initialConnect = true
    requestAnimationFrame(() => {
      this.initialConnect = false
    })
  }

  isCurrentValueChanged () {
    if (this.isCurrentValue) {
      if (!this.initialConnect) {
        this.element.scrollIntoView({ block: 'start', behavior: 'smooth' })
      }
      this.element.classList.add('is-current')
    } else {
      this.element.classList.remove('is-current')
    }
  }

  isCompletedValueChanged () {
    if (this.isCompletedValue) {
      this.element.classList.add('is-completed')
    } else {
      this.element.classList.remove('is-completed')
    }
  }
}
